import React from "react";
import { styles } from "../../stylesheets/simulateurs.css";
import ButtonYesno from "../buttons/button.yesno.js";
import Simulateur114 from "../../views/simulateurs/simulateur.114/simulateur.114";
import { ToolTipPerso } from "../selects/tooltip_perso";
import BadgeNouveau from "../texts/BadgeNouveau.js";

function CautionSansGarantieHypo(props) {
  const handleDependance114 = (obj) => {
    if (props.setSimu114) {
      props.setSimu114(obj);
    }
  };

  const cautionSansGarantieHypo = props.cautionSansGarantieHypo || 0;

  return (
    <>
      <div className="cardRow">
        <div style={styles.cardElemVerticalyCenter}>
          Y a-t-il une caution sans garantie hypothécaire ?
          <ToolTipPerso title={"Prêt, obligation, reconnaissance de dette, ouverture de crédit, sans garantie hypothécaire."}/>
          <BadgeNouveau cliquable={false}/>
        </div>
        <ButtonYesno
          handleChange={props.handleChange}
          setter={props.setCautionSansGarantieHypo}
          fieldUndefined={false}
          defaultValue={cautionSansGarantieHypo}
        />
      </div>

      {parseInt(cautionSansGarantieHypo) === 1 && (
        <Simulateur114
          simulateur={props.simulateur}
          isParent={false}
          departementId={props.departementId}
          dependances={handleDependance114}
        />
      )}
    </>
  );
}

export default CautionSansGarantieHypo;